import axiosInstance from './axiosConfig';
import { ApiResponse } from './generalService';

export interface VideoToken {
  url: string;
  token: string;
}

export const getPatientVideoToken = async (
  patientId: string
): Promise<VideoToken> => {
  const response = await axiosInstance.get<ApiResponse<VideoToken>>(
    `/video/admin/${encodeURIComponent(patientId)}/token`
  );
  const issued = response.data.result;

  if (!issued?.url || !issued?.token) {
    throw new Error('Video token response is missing url or token');
  }

  return issued;
};
